import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { createGroup as universalCreateGroup, updateGroup as universalUpdateGroup, deleteGroup as universalDeleteGroup, getGroup as universalGetGroup, getGroupBySlug as universalGetGroupBySlug, listGroups as universalListGroups, listGroupsByUserId as universalListGroupsByUserId, queryGroups as universalQueryGroups, queryJoinedGroups as universalQueryJoinedGroups, queryGroupsByMembership as universalQueryGroupsByMembership, listGroupIntegrationsData as universalListGroupIntegrationsData, getGroupBmFeatures as universalGetGroupBmFeatures, } from './social-groups-v2-group.universal';
import { Type, AllowPolicy, StepKey, PrivacyStatus, IdentityType, ContentType, SortOrder, MembershipStatus, BMFeaturesBMFeatures, WebhookIdentityType, } from './social-groups-v2-group.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.social_groups.v2.group', module_name: 'wix-groups.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        createGroup: (group, options) => {
            const methodLogData = {
                method_name: 'createGroup',
                service_name: 'wix.social.groups.api.v2.GroupsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-groups.v2,entity=wix.social_groups.v2.group,environment=velo-frontend,method-fqn=wix.social.groups.api.v2.GroupsService.createGroup',
            };
            return universalCreateGroup(group, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateGroup: (_id, group, options) => {
            const methodLogData = {
                method_name: 'updateGroup',
                service_name: 'wix.social.groups.api.v2.GroupsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-groups.v2,entity=wix.social_groups.v2.group,environment=velo-frontend,method-fqn=wix.social.groups.api.v2.GroupsService.updateGroup',
            };
            return universalUpdateGroup(_id, group, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteGroup: (groupId) => {
            const methodLogData = {
                method_name: 'deleteGroup',
                service_name: 'wix.social.groups.api.v2.GroupsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-groups.v2,entity=wix.social_groups.v2.group,environment=velo-frontend,method-fqn=wix.social.groups.api.v2.GroupsService.deleteGroup',
            };
            return universalDeleteGroup(groupId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getGroup: (groupId, options) => {
            const methodLogData = {
                method_name: 'getGroup',
                service_name: 'wix.social.groups.api.v2.GroupsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-groups.v2,entity=wix.social_groups.v2.group,environment=velo-frontend,method-fqn=wix.social.groups.api.v2.GroupsService.getGroup',
            };
            return universalGetGroup(groupId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getGroupBySlug: (slug, options) => {
            const methodLogData = {
                method_name: 'getGroupBySlug',
                service_name: 'wix.social.groups.api.v2.GroupsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-groups.v2,entity=wix.social_groups.v2.group,environment=velo-frontend,method-fqn=wix.social.groups.api.v2.GroupsService.getGroupBySlug',
            };
            return universalGetGroupBySlug(slug, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listGroups: (options) => {
            const methodLogData = {
                method_name: 'listGroups',
                service_name: 'wix.social.groups.api.v2.GroupsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-groups.v2,entity=wix.social_groups.v2.group,environment=velo-frontend,method-fqn=wix.social.groups.api.v2.GroupsService.listGroups',
            };
            return universalListGroups(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listGroupsByUserId: (options) => {
            const methodLogData = {
                method_name: 'listGroupsByUserId',
                service_name: 'wix.social.groups.api.v2.GroupsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-groups.v2,entity=wix.social_groups.v2.group,environment=velo-frontend,method-fqn=wix.social.groups.api.v2.GroupsService.listGroupsByUserId',
            };
            return universalListGroupsByUserId(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryGroups: (options) => {
            const methodLogData = {
                method_name: 'queryGroups',
                service_name: 'wix.social.groups.api.v2.GroupsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-groups.v2,entity=wix.social_groups.v2.group,environment=velo-frontend,method-fqn=wix.social.groups.api.v2.GroupsService.queryGroups',
            };
            return universalQueryGroups(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryJoinedGroups: (options) => {
            const methodLogData = {
                method_name: 'queryJoinedGroups',
                service_name: 'wix.social.groups.api.v2.GroupsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-groups.v2,entity=wix.social_groups.v2.group,environment=velo-frontend,method-fqn=wix.social.groups.api.v2.GroupsService.queryJoinedGroups',
            };
            return universalQueryJoinedGroups(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryGroupsByMembership: (options) => {
            const methodLogData = {
                method_name: 'queryGroupsByMembership',
                service_name: 'wix.social.groups.api.v2.GroupsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-groups.v2,entity=wix.social_groups.v2.group,environment=velo-frontend,method-fqn=wix.social.groups.api.v2.GroupsService.queryGroupsByMembership',
            };
            return universalQueryGroupsByMembership(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listGroupIntegrationsData: (options) => {
            const methodLogData = {
                method_name: 'listGroupIntegrationsData',
                service_name: 'wix.social.groups.api.v2.GroupsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-groups.v2,entity=wix.social_groups.v2.group,environment=velo-frontend,method-fqn=wix.social.groups.api.v2.GroupsService.listGroupIntegrationsData',
            };
            return universalListGroupIntegrationsData(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getGroupBmFeatures: (groupId) => {
            const methodLogData = {
                method_name: 'getGroupBmFeatures',
                service_name: 'wix.social.groups.api.v2.GroupsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-groups.v2,entity=wix.social_groups.v2.group,environment=velo-frontend,method-fqn=wix.social.groups.api.v2.GroupsService.getGroupBmFeatures',
            };
            return universalGetGroupBmFeatures(groupId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        Type,
        AllowPolicy,
        StepKey,
        PrivacyStatus,
        IdentityType,
        ContentType,
        SortOrder,
        MembershipStatus,
        BMFeaturesBMFeatures,
        WebhookIdentityType,
    };
}
//# sourceMappingURL=social-groups-v2-group.frontend.js.map